(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-persistent-cart"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ctr-header-banners"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("alpine:init", () => {
    Alpine.data("headerBanners", function () {
        return {
            init() {
                const banners = this.$el.querySelectorAll('[data-banner]');
                banners.forEach(banner => {
                    const destination = banner.dataset.destinationSelector;
                    const destinationElements = document.querySelectorAll(destination);

                    if (banner && destinationElements) {
                        destinationElements.forEach(destinationElement => {
                            destinationElement.appendChild(banner.cloneNode(true));
                        });
                    }
                });
            }
        }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
